import { defineComponent as _defineComponent } from 'vue'
import {
  BaseText,
  BrandImage,
  EBrandImageLogos,
  EBrandImageSchemas,
  Heading,
  SignupTemplate
} from '@warrenbrasil/nebraska-web';
import {
  ref,
  provide,
  computed,
  onBeforeMount,
  onMounted,
  onUnmounted
} from 'vue';
import { useRouter, useRoute } from 'vue-router/composables';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { Advisor, SignUpFormSteps } from '@/modules/onboarding/signup/types';
import { SignUpFormStepComponents } from '@/modules/onboarding/signup/helpers/step-component';
import FadeSlideTransition from '@/modules/common/components/FadeSlideTransition/FadeSlideTransition.vue';
import { FadeTransition } from '@/modules/common/components/FadeTransition';
import { getAdvisor } from '@/modules/onboarding/signup/services/api';
import { getThemeByParam } from '@/modules/common/services/http/account';
import {
  ICustomTheme,
  StorageKeys
} from '@/modules/common/services/local-storage';
import { setNebraskaScheme } from '@/modules/common/services/theme';
import { trackPageView } from '@/modules/onboarding/signup/helpers/track-events';


export default /*#__PURE__*/_defineComponent({
  __name: 'SignUp',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const formStep = ref<SignUpFormSteps>(SignUpFormSteps.Initial);
const userHaveAdvisor = ref<boolean>(false);
const isAdvisorModalOpen = ref<boolean>(false);
const firstName = ref<string>('');
const email = ref<string>('');
const imageVisible = ref(true);
const advisor = ref<Advisor>({
  id: '',
  name: '',
  image: '',
  email: ''
});
const advisorLoading = ref<boolean>(false);
const partnerTheme = ref<ICustomTheme | null>(null);
const partnerThemeLoading = ref<boolean>(true);

function onBackClick() {
  if (isAdvisorModalOpen.value) {
    isAdvisorModalOpen.value = false;
    return;
  }

  if (formStep.value === SignUpFormSteps.Password) {
    formStep.value = SignUpFormSteps.Initial;
    return;
  }

  router.push({ name: 'signin' });
}

const slideAnimationActive = computed(() => {
  return window.innerWidth > 1024;
});

const templateBackground = computed(() => {
  return !partnerTheme.value ? NebraskaColors.backgroundSecondary : undefined;
});

const gradientBackgroundActive = computed(() => {
  return !partnerTheme.value && !partnerThemeLoading.value;
});

const componentStep = computed(() => {
  return SignUpFormStepComponents[formStep.value];
});

function changeStep(step: SignUpFormSteps) {
  formStep.value = step;
}

const windowWidth = ref(window.innerWidth);
const updateWidth = () => {
  windowWidth.value = window.innerWidth;
};

const isMobile = computed(() => windowWidth.value < 768);

onMounted(() => {
  window.addEventListener('resize', updateWidth);
  document.body.classList.add('signup-page-active');
});
onUnmounted(() => {
  window.removeEventListener('resize', updateWidth);
  document.body.classList.remove('signup-page-active');
});

async function checkPartnerQueryParam() {
  partnerThemeLoading.value = true;
  advisorLoading.value = true;
  if (route.query.advisor) {
    const advisorEmail = route.query.advisor as string;

    try {
      const advisorResponse = await getAdvisor(advisorEmail);
      advisor.value = { ...advisorResponse };
      userHaveAdvisor.value = true;
    } catch {
      advisor.value = { id: '', name: '', image: '', email: '' };
    }

    try {
      const themeResponse = await getThemeByParam('email', advisorEmail);
      if (themeResponse.type !== 'WarrenManaged') {
        partnerTheme.value = themeResponse;
        localStorage.setItem(StorageKeys.Theme, JSON.stringify(themeResponse));
        setNebraskaScheme(themeResponse);
        localStorage.setItem(StorageKeys.WhitelabelTheme, 'whitelabel');
      }
    } catch {
      partnerTheme.value = null;
    }
  }
  advisorLoading.value = false;
  partnerThemeLoading.value = false;
}

onBeforeMount(async () => {
  checkPartnerQueryParam();
  trackPageView();
});

provide('isMobile', isMobile);
provide('changeStep', changeStep);
provide('advisor', advisor);
provide('advisorLoading', advisorLoading);
provide('userHaveAdvisor', userHaveAdvisor);
provide('firstName', firstName);
provide('partnerTheme', partnerTheme);
provide('partnerThemeLoading', partnerThemeLoading);
provide('email', email);
provide('isAdvisorModalOpen', isAdvisorModalOpen);
provide('updateIsAdvisorModalOpen', (value: boolean) => {
  isAdvisorModalOpen.value = value;
});
provide('updateUserHaveAdvisor', (value: boolean) => {
  userHaveAdvisor.value = value;
});
provide('updateAdvisor', (value: Advisor) => {
  advisor.value = value;
});
provide('updateAdvisorLoading', (value: boolean) => {
  advisorLoading.value = value;
});
provide('updateFirstName', (value: string) => {
  firstName.value = value;
});
provide('updateEmail', (value: string) => {
  email.value = value;
});

return { __sfc: true,router, route, formStep, userHaveAdvisor, isAdvisorModalOpen, firstName, email, imageVisible, advisor, advisorLoading, partnerTheme, partnerThemeLoading, onBackClick, slideAnimationActive, templateBackground, gradientBackgroundActive, componentStep, changeStep, windowWidth, updateWidth, isMobile, checkPartnerQueryParam, BaseText, BrandImage, EBrandImageLogos, EBrandImageSchemas, Heading, SignupTemplate, NebraskaColors, FadeSlideTransition, FadeTransition }
}

})